export enum Integrip1Permissions {
  Monitoring = 'intergrip1-monitoring',
  Manage = 'intergrip1-manage',
}
